"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMonoSpaceFont = void 0;
function isMonoSpaceFont(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput;
    it('Should be monospace font by default', function () {
        loadPrimaryInput().then(function (inputElem) { return inputElem.css('font-family'); }).should('eq', 'monospace');
    });
}
exports.isMonoSpaceFont = isMonoSpaceFont;
